import {createBrowserRouter} from 'react-router';
import {authGuard} from '@common/auth/guards/auth-route';
import React from 'react';
import {RootErrorElement, RootRoute} from '@common/core/common-provider';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {authRoutes} from '@common/auth/auth-routes';
import {notificationRoutes} from '@common/notifications/notification-routes';
import {adminRoutes} from '@common/admin/routes/admin-routes';
import {checkoutRoutes} from '@common/billing/checkout/routes/checkout-routes';
import {billingPageRoutes} from '@common/billing/billing-page/routes/billing-page-routes';
import {commonRoutes} from '@common/core/common-routes';
import {siteRoutes} from '@app/routes/site-routes';
import {appAuthRoutes} from '@app/auth/app-auth-routes';
import {appCommonRoutes} from '@app/routes/app-common-routes';
import {FullPageLoader} from '@ui/progress/full-page-loader';

export const appRouter = createBrowserRouter(
  [
    {
      id: 'root',
      element: <RootRoute />,
      errorElement: <RootErrorElement />,
      hydrateFallbackElement: <FullPageLoader screen />,
      children: [
        // CUSTOM(albaniantheatre): must come before "authRoutes" so the login
        // route with the Cloudflare Turnstile challenge wins
        ...appAuthRoutes,
        ...authRoutes,
        ...notificationRoutes,
        ...adminRoutes,
        ...checkoutRoutes,
        ...billingPageRoutes,
        // CUSTOM(albaniantheatre): must come before "commonRoutes" so custom
        // pages and the contact page keep the site header
        ...appCommonRoutes,
        ...commonRoutes,
        ...siteRoutes,
        {
          // CUSTOM(albaniantheatre): the API docs were reachable by guests with
          // the stock "api.access" guard. The client wants them admin-only, so
          // this requires a login *and* admin.access; routes/web.php gates the
          // swagger.yaml spec the page loads with the same permission.
          path: 'api-docs',
          loader: () =>
            authGuard({permission: 'admin.access', requireLogin: true}),
          lazy: () => import('@common/swagger/swagger-api-docs-page'),
        },
      ],
    },
  ],
  {
    basename: getBootstrapData().settings.html_base_uri,
  },
);
